import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { viewService } from '@unpispas/upp-base';

/** Static asset path for the waiting animation (copied via `angular.json` from `libs/upp-wdgt/assets`). */
export const UPP_OFFLINE_LOADING_IMAGE = 'assets/upp-wdgt/image/beer-loading.gif';

/**
 * Offline waiting card: preloads the loading gif while hidden and shows progress + message when visible.
 * Parent controls visibility with `[hidden]` on the host so the image stays in the DOM cache.
 */
@Component({
    selector: 'upp-offline',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-offline.html',
    styleUrls: ['./upp-offline.scss'],
})
export class UppOfflineComponent {
    /** Status line shown below the progress bar. */
    @Input() message: string | null = null;

    readonly LoadingImageUrl = UPP_OFFLINE_LOADING_IMAGE;

    constructor(public view: viewService) {
        // nothing to do
    }
}
